<template>
  <v-row no-gutters>
    <v-col cols="4" class="d-none d-md-flex">
      <CarouselVue :images="$store.getters.uniLeft" />
    </v-col>
    <v-col sm="12" md="4" class="d-xs-block AuthPanel">
      <v-row>
        <v-col>
          <v-img class="logo" src="/assets/img/Logo/logo.gif" min-width="205"></v-img>
          <h1 class="login-head">Code verification</h1>
          <p class="forget-p">You can set your new password here</p>

          <v-form ref="form" class="formforgtcss" v-model="valid">
            <div class="mb-3">
              <v-text-field hint="Email Address" persistent-hint dark type="email" v-model="email" class="mx-12"
                :rules="required" :disabled="disabler" />
              <v-text-field hint="Code" persistent-hint dark type="number" v-model="code" class="mx-12"
                :rules="required" :disabled="disabler" />
            </div>

            <v-row v-if="disabler">
              <v-col>
                <v-text-field hint="New password" persistent-hint dark type="password" v-model="password" class="mx-12"
                  :rules="required"></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col v-if="!disabler">
                <button @click.prevent="verifyCode" class="btn btn-primary" :disabled="disabler">
                  Verify Code
                </button>
              </v-col>
              <v-col v-else>
                <button @click.prevent="changePassword" class="btn btn-primary">
                  Change password
                </button>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">{{ txt }}</v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="4" class="d-none d-md-flex">
      <CarouselVue :images="$store.getters.uniRight" />
    </v-col>
  </v-row>
</template>

<script>
import CarouselVue from "../../../components/auth/Carousel.vue";
import axios from "axios";
export default {
  components: {
    CarouselVue,
  },
  data() {
    return {
      txt: "",
      code: "",
      email: "",
      password: "",
      valid: false,
      disabler: false,
      required: [(v) => !!v || "This field is required"],
    };
  },
  methods: {
    async verifyCode() {
      try {
        if (!this.email && !this.code)
          throw new Error("Please enter your email and code");
        const resp = await axios({
          url: "auth/verify/code",
          method: "POST",
          data: {
            email: this.email,
            code: this.code,
          },
        });
        this.txt = resp.data.message;
        this.disabler = true;
      } catch (error) {
        console.error(error);
      }
    },
    async changePassword() {
      try {
        if (!this.email && !this.code)
          throw new Error("Please enter your email and code");
        const resp = await axios({
          url: "auth/verify/code",
          method: "POST",
          data: {
            email: this.email,
            code: this.code,
          },
        });
        this.txt = resp.data.message;
        this.disabler = true;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
<style scoped>
::placeholder {
  color: #8a6e2f;
  opacity: 1;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #8a6e2f;
  opacity: 1;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #8a6e2f;
  opacity: 1;
}
</style>
